export default "__VITE_ASSET__BBoj_vET__"